var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.8917 0H0.5L87.8917 87.3917V0Z",
    fill: "url(#paint0_radial_4039_377)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3688 21.5109L61.8512 13.3817C61.7818 13.2182 61.6497 13.079 61.4728 13.0039C61.1078 12.8514 60.6869 13.0171 60.5324 13.3773L57.0126 21.5087L48.1122 22.2975C47.9241 22.3086 47.7427 22.3881 47.6106 22.5384C47.3509 22.8323 47.38 23.2786 47.6778 23.5349L54.4309 29.355L52.4336 37.9769C52.3933 38.1471 52.418 38.3327 52.5165 38.4962C52.7202 38.8299 53.1591 38.9403 53.4994 38.7393L61.1907 34.2007L68.8573 38.726C69.0163 38.8276 69.2133 38.8674 69.4104 38.8232C69.7977 38.7348 70.0373 38.3548 69.95 37.9747L67.9527 29.3528L74.7013 23.5371C74.8357 23.42 74.9275 23.2565 74.9432 23.0665C74.9767 22.6776 74.6857 22.3351 74.2916 22.3019L65.3688 21.5109Z",
    fill: "url(#paint1_angular_4039_377)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4039_377",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.8917) rotate(134.484) scale(100.876)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204252,
    stopColor: "#1378A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1378A5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_4039_377",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.092 28.0831) rotate(51.552) scale(13.6836 14.3918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD177"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.917d72ba166d447ad41841fa696e1a65.svg";
export { ForwardRef as ReactComponent };